module.exports = __webpack_public_path__ + "static/media/rs.f859c073.png";